export type IncreaseContentManagement = {
  ContentId: string;
};

export type IncreaseContentManagementRep = {
  ViewCountInfo: InfoViewCount[];
};

type InfoViewCount = {
  Id: string;
  ViewCount: number;
};

export class IncreaseContentManagementQueryMap {
  payload?: any;

  set(payload?: IncreaseContentManagement) {
    this.payload = {
      ...payload,
    };
  }
}
